import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {checkHidden} from "../../../../../Utils/Form/FormDynamic/Utils/checkHidden";
import Typography from "@material-ui/core/Typography";
import {multiLanguageValue} from "../../../Utils/lib";
import {useSelector} from "react-redux";

const useStyles = makeStyles(() => ({
    flexRow: {
        display: 'flex',
        height: '27px'
    },
    cellHead: {
        border: '1px solid #f2f2f2',
        outline: 'none',
        background: 'rgb(237, 237, 237)',
        position: 'relative',
    },
}));
const TableHeader = ({globalValues, element, screenName}) => {
    const classes = useStyles();
    const {userLanguage} = useSelector(state => state.app);
    return (
        <div className={classes.flexRow}>
            {element.children.map((field, index) => {
                const isHidden = checkHidden(globalValues, field.properties.hideCondition, screenName);
                const multiLanguageLabel = multiLanguageValue(field.properties.label, userLanguage)
                const styles = field.styles ? field.styles[0] : {};
                if (field.properties.hidden) return <></>;
                return (
                    <div key={`field.properties.label_${index}`}
                        style={{
                            display: isHidden ? 'none' : 'block',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            width: styles.width || 'auto'
                        }}
                        className={classes.cellHead}
                    >
                        <Typography component={'span'}>
                            {multiLanguageLabel}
                            {field.properties.required && <span style={{color: 'red'}}>*</span>}
                        </Typography>

                    </div>
                )
            })}
        </div>

    )
};
export default TableHeader